import script from './SdsToggleSwitch.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sds-toggle-switch sds-focus",class:{
        'sds-toggle-switch--md': _vm.size === 'md',
        'sds-toggle-switch--sm': _vm.size === 'sm',
        'sds-toggle-switch--active': _vm.isActive,
        'sds-toggle-switch--disabled': _vm.isDisabled,
    },attrs:{"role":"switch","type":"button","disabled":_vm.isDisabled,"aria-checked":_vm.isActive ? 'true' : 'false'},on:{"click":function($event){!_vm.isDisabled && _vm.$emit('update:isActive', !_vm.isActive);}}},[_c('div',{staticClass:"sds-toggle-switch__knob"},[_c('SdsIcon',{staticClass:"sds-toggle-switch__icon",attrs:{"iconName":_vm.isActive ? 'status-checkmark-small' : 'navigation-close-small',"size":_vm.size}})],1)])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-f0edfe9e_0", { source: ".sds-toggle-switch[data-v-f0edfe9e]{--transitions-duration:120ms;--switch-padding:2px;display:flex;align-items:center;flex-shrink:0;padding:var(--switch-padding);width:calc(var(--item-width-without-padding) + 2 * var(--switch-padding));border-radius:var(--radius-full);background-color:var(--component-toggle-switch-inactive-bg);transition:background-color var(--transitions-duration) linear;border:none;appearance:none;cursor:pointer}.sds-toggle-switch .sds-toggle-switch__knob[data-v-f0edfe9e]{transition:transform var(--transitions-duration) ease-in-out,background-color var(--transitions-duration) linear,color var(--transitions-duration) linear;display:flex;align-items:center;justify-content:center;border-radius:var(--radius-full);overflow:hidden;background-color:var(--component-toggle-switch-inactive-knob);color:var(--component-toggle-switch-inactive-icon)}.sds-toggle-switch--md[data-v-f0edfe9e]{--item-width-without-padding:40px;height:24px}.sds-toggle-switch--md .sds-toggle-switch__knob[data-v-f0edfe9e]{height:20px;width:20px}.sds-toggle-switch--sm[data-v-f0edfe9e]{--item-width-without-padding:26px;height:16px}.sds-toggle-switch--sm .sds-toggle-switch__knob[data-v-f0edfe9e]{height:12px;width:12px}.sds-toggle-switch--active[data-v-f0edfe9e]{background-color:var(--component-toggle-switch-active-bg)}.sds-toggle-switch--active .sds-toggle-switch__knob[data-v-f0edfe9e]{transform:translateX(calc(var(--item-width-without-padding) - 100%));background-color:var(--component-toggle-switch-active-knob);color:var(--component-toggle-switch-active-icon)}.sds-toggle-switch--disabled[data-v-f0edfe9e]{background-color:var(--component-toggle-switch-disabled-bg);cursor:not-allowed}.sds-toggle-switch--disabled .sds-toggle-switch__knob[data-v-f0edfe9e]{background-color:var(--component-toggle-switch-disabled-knob);color:var(--component-toggle-switch-disabled-icon)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-f0edfe9e";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
